import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { ProductList } from '../../models/product-list.model';
import { ProductDetailViewModel } from '../../models/product-detail-view-model';

@Component({
  selector: 'app-product-detail-shipping-info',
  templateUrl: './product-detail-shipping-info.component.html',
  styleUrls: ['./product-detail-shipping-info.component.scss'],
})
export class ProductDetailShippingInfoComponent implements OnInit, OnChanges {
  readonly i18nShippingInfoId = 'i18n.productDetail.shippingInfo.';
  @Input() product: ProductDetailViewModel;
  isManufacturerSectionDefined = false;
  isManufacturerNameDefined = false;
  isManufacturerNumberDefined = false;

  isClassificationSectionDefined = false;
  isClassificationGroupDefined = false;
  isClassificationClassDefined = false;
  isClassificationCategoryDefined = false;

  shippingDetails: ProductList[] = [];
  storageInfos: ProductList[] = [];
  showAllShippingInformation = false;
  showShippingDetails = false;
  showStorageInformation = false;
  productDetailManufacturerName;
  productSummaryBrand;
  productDetailManufacturerProductNumber;

  constructor() {}

  ngOnInit() {
    this.checkAllSectionsDefinition();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.product?.currentValue) {
      this.checkAllSectionsDefinition();
      this.formatShippingInfos();
      this.checkShippingInformationView();
    }
  }

  checkShippingInformationView() {
    this.showShippingDetails = this.shippingDetails.some(s => s.visible);
    this.showStorageInformation = this.storageInfos.some(t => t.visible);
    this.showAllShippingInformation =
      this.showShippingDetails || this.showStorageInformation;
    this.isManufacturerSectionDefined || this.isClassificationSectionDefined;
  }

  private formatShippingInfos() {
    const {
      grossWeight,
      netWeight,
      weightUom,
      purchasePackHeight,
      purchasePackWidth,
      purchasePackDepth,
      purchasePackUOM,
      volume,
      volumeUnits,
      storageTemperatureMin,
      storageTemperatureMax,
      temperatureUom,
      storageCode,
      storageCodeDescription,
    } = this.product?.detail;

    this.shippingDetails = [
      {
        keyLabel: `${this.i18nShippingInfoId}shippingData.grossWeight`,
        value: `${grossWeight} ${weightUom?.toLowerCase()}s`,
        visible: !!grossWeight && !!weightUom,
      },
      {
        keyLabel: `${this.i18nShippingInfoId}shippingData.netWeight`,
        value: `${netWeight} ${weightUom?.toLowerCase()}s`,
        visible: !!netWeight && !!weightUom,
      },
      {
        keyLabel: `${this.i18nShippingInfoId}shippingData.height`,
        value: `${purchasePackHeight}  in`,
        visible: !!purchasePackHeight,
      },
      {
        keyLabel: `${this.i18nShippingInfoId}shippingData.width`,
        value: `${purchasePackWidth}  in`,
        visible: !!purchasePackWidth,
      },
      {
        keyLabel: `${this.i18nShippingInfoId}shippingData.length`,
        value: `${purchasePackDepth}  in`,
        visible: !!purchasePackDepth,
      },
      {
        keyLabel: `${this.i18nShippingInfoId}shippingData.cube`,
        value: `${volume}  ${volumeUnits}`,
        visible: volume != null,
      },
      {
        keyLabel: `${this.i18nShippingInfoId}shippingData.catchWeight`,
        value: this.product?.summary?.catchWeightFlag ? 'Yes' : 'No',
      },
    ];

    this.storageInfos = [
      {
        keyLabel: `${this.i18nShippingInfoId}storageData.usfStorage`,
        value: `${storageCodeDescription} ${storageCode}`,
        visible: !!storageCodeDescription,
      },
      {
        keyLabel: `${this.i18nShippingInfoId}storageData.minTemp`,
        value: `${storageTemperatureMin} ${temperatureUom}`,
        visible: !!storageTemperatureMin,
      },
      {
        keyLabel: `${this.i18nShippingInfoId}storageData.maxTemp`,
        value: `${storageTemperatureMax} ${temperatureUom}`,
        visible: !!storageTemperatureMax,
      },
    ];
  }

  private checkAllSectionsDefinition(): void {
    this.checkClassificationSectionDefinition();
    this.checkManufacturerSectionDefinition();
  }

  private checkManufacturerSectionDefinition(): void {
    this.isManufacturerNameDefined =
      !!this.product?.detail?.manufacturerName?.trim() ||
      (!!this.product?.summary?.isExclusiveBrand &&
        !!this.product?.summary?.brand?.trim());
    this.isManufacturerNumberDefined = !!this.product?.detail?.manufacturerNumber?.trim();

    this.isManufacturerSectionDefined =
      this.isManufacturerNumberDefined || this.isManufacturerNameDefined;

    if (
      this.isManufacturerNameDefined &&
      !this.product?.summary?.isExclusiveBrand
    ) {
      this.productDetailManufacturerName = this.product?.detail?.manufacturerName;
    }
    if (
      this.isManufacturerNameDefined &&
      this.product?.summary?.isExclusiveBrand
    ) {
      this.productSummaryBrand = this.product?.summary?.brand;
    }
    if (this.product?.detail?.manufacturerProductNumber) {
      this.productDetailManufacturerProductNumber = this.product?.detail?.manufacturerProductNumber;
    }
  }

  private checkClassificationSectionDefinition(): void {
    this.isClassificationClassDefined =
      !!this.product?.summary?.classCode ||
      !!this.product?.summary?.classDescription;
    this.isClassificationGroupDefined =
      !!this.product?.summary?.groupCode ||
      !!this.product?.summary?.groupDescription;
    this.isClassificationCategoryDefined =
      !!this.product?.summary?.categoryCode ||
      !!this.product?.summary?.categoryDescription;

    this.isClassificationSectionDefined =
      this.isClassificationClassDefined ||
      this.isClassificationGroupDefined ||
      this.isClassificationCategoryDefined;
  }
}
